import styled from 'styled-components';
import UIBox from 'UIComponents/layout/UIBox';
const CollapsableSidebarContainer = styled(UIBox).withConfig({
  displayName: "CollapsableSidebarContainer",
  componentId: "sc-1od9du2-0"
})(["position:relative;height:100%;flex-basis:", "px;transition:all 200ms cubic-bezier(0.42,0,0.58,1);"], props => props.width);
export default CollapsableSidebarContainer;